import {useHandleAction} from '../../internal/useHandleAction'
import {useShopActions} from '../../internal/useShopActions'
import {ShareParams} from '../../types'

interface UseShareReturns {
  /**
   * Closes the Mini viewer.
   */
  share: (params: ShareParams) => void
}

export const useShare = (): UseShareReturns => {
  const {share} = useShopActions()

  return {
    share: useHandleAction(share),
  }
}
